var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    height: 1000,
    width: 857.143,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M857.088 500.032q0 116.622-57.474 215.109T643.653 871.102t-215.109 57.474-215.109-57.474T57.474 715.141 0 500.032t57.474-215.109 155.961-155.961 215.109-57.474 215.109 57.474 155.961 155.961 57.474 215.109z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGhlaWdodD0iMTAwMCIgd2lkdGg9Ijg1Ny4xNDMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iIzAwMDAwMCIgZD0iTTg1Ny4wODggNTAwLjAzMnEwIDExNi42MjIgLTU3LjQ3NCAyMTUuMTA5dC0xNTUuOTYxIDE1NS45NjEgLTIxNS4xMDkgNTcuNDc0IC0yMTUuMTA5IC01Ny40NzQgLTE1NS45NjEgLTE1NS45NjEgLTU3LjQ3NCAtMjE1LjEwOSA1Ny40NzQgLTIxNS4xMDkgMTU1Ljk2MSAtMTU1Ljk2MSAyMTUuMTA5IC01Ny40NzQgMjE1LjEwOSA1Ny40NzQgMTU1Ljk2MSAxNTUuOTYxIDU3LjQ3NCAyMTUuMTA5eiIvPjwvc3ZnPg==";
export { SvgCircle as ReactComponent };